<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <template
          v-for="(specie, key) in speciesRefRange.filter(
            (refRange) => refRange.is_custom
          )"
        >
          <b-row :key="key" class="py-2">
            <b-col cols="2" class="my-auto">{{ specie.species_name }}</b-col>
            <b-col cols="2" class="my-auto">{{ specie.custom_name }}</b-col>
            <b-col cols="2" class="my-auto">
              <b-form-select
                v-model="specie.ref_range_type"
                text-field="title"
                value-field="value"
                :options="refRangeTypeList"
              />
            </b-col>
            <template
              v-if="
                specie.ref_range_type == 'legacy' ||
                  specie.ref_range_type == null
              "
            >
              <b-col class="my-auto" cols="2">
                <b-form-input v-model="specie.min" />
              </b-col>
              <b-col cols="2" class="my-auto">
                <b-form-input v-model="specie.max" />
              </b-col>
            </template>
            <template v-if="specie.ref_range_type == 'all'">
              <b-col class="my-auto" cols="4">
                <b-form-textarea
                  v-model="specie.ref_range_text"
                  placeholder="<1.0ug/dL  : Low ......>"
                  rows="3"
                  max-rows="6"
                />
              </b-col>
            </template>

            <b-col cols="2" class="my-auto">
              <b-button
                variant="danger"
                @click="deleteCustomRefRangeHandler(specie.ref_range_id)"
                >ลบ</b-button
              >
            </b-col>
          </b-row>
        </template>
        <template
          v-for="(specie, key) in speciesRefRange.filter(
            (refRange) => !refRange.is_custom
          )"
        >
          <b-row :key="key" class="py-2">
            <b-col cols="3" class="my-auto">{{ specie.species_name }}</b-col>
            <b-col cols="2" class="my-auto">
              <b-form-select
                v-model="specie.ref_range_type"
                text-field="title"
                value-field="value"
                :options="refRangeTypeList"
              />
            </b-col>
            <template
              v-if="
                specie.ref_range_type == 'legacy' ||
                  specie.ref_range_type == null
              "
            >
              <b-col class="my-auto" cols="3">
                <b-row>
                  <b-col cols="auto" class="my-auto">Min</b-col>
                  <b-col cols="auto" class="my-auto">
                    <b-form-input v-model="specie.min" />
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="3" class="my-auto">
                <b-row>
                  <b-col cols="auto" class="my-auto">Max</b-col>
                  <b-col cols="auto" class="my-auto">
                    <b-form-input v-model="specie.max" />
                  </b-col>
                </b-row>
              </b-col>
            </template>
            <template v-if="specie.ref_range_type == 'all'">
              <b-col class="my-auto" cols="6">
                <b-form-textarea
                  v-model="specie.ref_range_text"
                  placeholder="<1.0ug/dL  : Low ......>"
                  rows="3"
                  max-rows="6"
                />
              </b-col>
            </template>
          </b-row>
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RefRange",
  props: {
    type: {
      type: String,
      default: "test",
    },
    testId: {
      type: Number,
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      refRangeFields: [
        {
          key: "species_name",
          name: "ชื่อสปีชีส์",
        },
        {
          key: "min",
          name: "Min",
        },
        {
          key: "max",
          name: "Max",
        },
      ],
      refRangeTypeList: [
        {
          title: "แบบเก่า",
          value: "legacy",
        },
        {
          title: "แบบใหม่",
          value: "all",
        },
      ],
    };
  },
  computed: {
    speciesRefRange: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async mounted() {
    this.$store.state.isLoading = true;
    if (this.type === "test") {
      this.speciesRefRange = await this.getTestRefRangeList(this.testId);
    } else if (this.type === "subTest") {
      this.speciesRefRange = await this.getSubTestRefRangeList(this.testId);
    }
    this.$store.state.isLoading = false;
  },
  methods: {
    ...mapActions({
      getTestRefRangeList: "Test/getTestRefRangeList",
      getSubTestRefRangeList: "Test/getSubTestRefRangeList",
      updateRefRangeList: "Test/updateRefRangeList",
      deleteCustomRefRange: "Test/deleteCustomRefRange",
    }),
    async deleteCustomRefRangeHandler(refRangeId) {
      const { value: password } = await this.$swal.fire({
        title: "กรอกรหัสผ่านเพื่อดำเนินการต่อไป",
        input: "password",
        inputAttributes: {
          autocapitalize: "off",
          autocorrect: "off",
        },
      });

      if (password) {
        this.$store.state.isLoading = true;
        await this.deleteCustomRefRange({ id: refRangeId, password });

        await this.$swal.fire(
          "สำเร็จ",
          "บันทึก Ref Range ใหม่เสร็จสิ้น",
          "success"
        );

        if (this.type === "test") {
          this.speciesRefRange = await this.getTestRefRangeList(this.testId);
        } else if (this.type === "subTest") {
          this.speciesRefRange = await this.getSubTestRefRangeList(this.testId);
        }
        this.$store.state.isLoading = false;
      } else {
        return;
      }
    },
  },
};
</script>

<style scoped></style>
